// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.reflect.own-keys.js
// module id = 518
// module chunks = 0